import Address from "../components/Address";
import CustomLink from "../components/CustomLink";
import Heading from "../components/Heading";
import Layout from "../components/Layout";
import classNames from "classnames/bind";
import gridStyle from "../components/Grid.module.css";
import styles from "./ContactPage.module.css";
import wave from "../assets/wave.svg";
import Image from "../components/Image";

export default function Contact({ coreData, pageData, pathName }) {
  return (
    <Layout coreData={coreData} theme="light" pathName={pathName}>
      <div className={styles.ContactPage}>
        <div className={classNames(styles.introSection, gridStyle.grid)}>
          <Heading className={styles.introHeading}>
            Get in touch with us{" "}
            <span className={styles.desktopEmail}>
              here
              <br />
              <CustomLink href="mailto:thecrew@wearecrew.com">
                thecrew@wearecrew.com
              </CustomLink>
            </span>
            <span className={styles.mobileEmail}>
              <CustomLink href="mailto:thecrew@wearecrew.com">here</CustomLink>
            </span>
          </Heading>
          <div className={styles.wave}>
            <span className={styles.waveItem}>
              <img src={wave} alt={""} />
            </span>
          </div>
        </div>
        <div className={classNames(styles.addressSection, gridStyle.grid)}>
          <p className={styles.addressHeading1}>Address</p>
          <div className={styles.addressDetails}>
            <div className={styles.addressHeading2}>
              {pageData.addressHeading}
            </div>
            <Address />
          </div>
        </div>
        <div className={styles.linkSection}>
          <Heading className={styles.links}>
            <CustomLink
              href={coreData.socialLinks.twitterUrl}
              className={styles.link}
            >
              X
            </CustomLink>
            <CustomLink
              href={coreData.socialLinks.vimeoUrl}
              className={styles.link}
            >
              Vimeo
            </CustomLink>
            <CustomLink
              href={coreData.socialLinks.linkedinUrl}
              className={styles.link}
            >
              LinkedIn
            </CustomLink>
            <CustomLink
              href={coreData.socialLinks.instagramUrl}
              className={styles.link}
            >
              Instagram
            </CustomLink>
          </Heading>
        </div>
      </div>
    </Layout>
  );
}
